// extracted by mini-css-extract-plugin
export var description = "styles-module--description--050bd";
export var item = "styles-module--item--8de65";
export var title = "styles-module--title--efcd2";